import { render, staticRenderFns } from "./TwoFactorsSetupDialog.vue?vue&type=template&id=ec86cac4&"
import script from "./TwoFactorsSetupDialog.vue?vue&type=script&lang=js&"
export * from "./TwoFactorsSetupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports